import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from 'components/CncUI/Typography';
import LogoImage from 'images/MyCast&CrewBlackLogo.svg';
import LoadingImg from 'images/loading.gif';

const useStyles = makeStyles(({ palette }) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
  },
  fullScreenRoot: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100vw',
    height: '100vh',
    flexDirection: 'column',
  },
  progress: {
    padding: 15,
    color: palette.cncUI.default.primary,
  },
  message: {
    padding: 15,
  },
  logo: {
    width: 220,
  },
}));

const Loader = props => {
  const classes = useStyles();
  const {
    variant,
    value,
    thickness,
    size,
    message,
    messageProps = {},
    className,
    fullScreen = false,
    withLogo = false,
  } = props;

  const progressProps = { variant, value, thickness, size };
  // Pull the className out to combine with our className
  const { className: messageClassName } = messageProps;
  let updatedMessageProps = { ...messageProps };
  delete updatedMessageProps.className;

  const rootClass = clsx(
    {
      [classes.root]: !fullScreen,
      [classes.fullScreenRoot]: fullScreen,
    },
    className,
  );

  return (
    <div className={rootClass} data-test-id={`Loader-root`}>
      {withLogo && fullScreen ? (
        <>
          <img
            src={LogoImage}
            alt="MyCast&Crew Logo"
            className={classes.logo}
          />
          <img src={LoadingImg} alt="Loading..." style={{ marginTop: 20 }} />
        </>
      ) : (
        <CircularProgress className={classes.progress} {...progressProps} />
      )}
      {message && (
        <Typography
          className={clsx(classes.message, messageClassName)}
          variant={'caption'}
          data-test-id={`Loader-message`}
          {...updatedMessageProps}
        >
          {message}
        </Typography>
      )}
    </div>
  );
};

export default Loader;
